import * as React from 'react';
import {
    Checkbox, DefaultButton, Dropdown, getId, Icon, Modal, PrimaryButton
} from '@fluentui/react';
import { OrderUtils } from '../../shared/OrderUtils';
import { StyleUtils } from '../../../../common/views/StyleUtils';
import { Utils } from '../../../../common/views/Utils';
import { OrderFilterModel } from '../../../models/OrderModel';
import { SortModel } from '../../../../home/models/PageTypes';
import {
    defaultButtonStyles, dropdownStyles, primaryButtonStyles
} from '../../../../common/views/DefaultStyles';

type OrderFilterProps = {
    form: OrderFilterModel;
    onValueChange: (field: keyof OrderFilterModel, value: any) => void;
    onClose: () => void;
    onSubmit: () => void;
}

export default function OrderFilterView({ form, onClose, onValueChange, onSubmit }: OrderFilterProps) {
    const _titleId: string = getId('title');
    const _subtitleId: string = getId('subText');

    const width2 = Utils.getColumnWidth(2);
    const width6 = Utils.getColumnWidth(6);
    const width10 = Utils.getColumnWidth(10);

    const onSortChange = (event: React.FormEvent<HTMLDivElement>, option?: any) => {
        if (!option) return;
        if (form.sortModel.name === option.key) return;

        let sortModel = new SortModel();
        sortModel.key = option.key;
        sortModel.name = option.name;
        sortModel.text = option.text;
        sortModel.direction = option.direction;

        onValueChange("sortModel", sortModel);
        onValueChange("pageNumber", 1);
    }

    const header = () => {
        return <div className="ms-Grid">
            <div className="ms-Grid-row">
                <div className={width10}><b>Order Sort & Filters</b></div>
                <div className={width2 + " right"}>
                    <Icon iconName="ChromeClose" className="pointer" onClick={onClose} />
                </div>
            </div>
        </div>;
    }

    const sortByPicker = () => {
        return <div className="ms-Grid-row">
            <Dropdown
                label="Sort By"
                selectedKey={form.sortModel.key}
                onChange={onSortChange}
                options={OrderUtils.getSortOptions()}
                styles={dropdownStyles} />
        </div>;
    }

    const reasonPicker = () => {
        return <div className="ms-Grid-row pt-10">
            <Dropdown
                label="Reject Reason"
                selectedKey={form.reason}
                onChange={(_, v) => onValueChange("reason", v?.key || 0)}
                options={OrderUtils.getReasonOptions()}
                styles={dropdownStyles} />
        </div>;
    }

    const trackingPicker = () => {
        return <div className="ms-Grid-row pt-10">
            <Dropdown
                label="Tracking"
                selectedKey={form.tracking}
                onChange={(_, v) => onValueChange("tracking", v?.key || 0)}
                options={OrderUtils.getTrackingOptions()}
                styles={dropdownStyles} />
        </div>;
    }

    const allWarehouseCheckbox = () => {
        return <div className="ms-Grid-row pt-15">
            <Checkbox
                label="All Warehouse?"
                checked={form.isAllWarehouses}
                disabled={true}
                onChange={(_, v) => onValueChange("isAllWarehouses", v || false)} />
        </div>;
    }

    const openOnlyCheckbox = () => {
        return <div className="ms-Grid-row pt-15">
            <Checkbox
                label="Open Only?"
                checked={form.isOpen}
                onChange={(_, v) => onValueChange("isOpen", v || false)} />
        </div>;
    }

    const noInvoiceCheckbox = () => {
        return <div className="ms-Grid-row pt-15">
            <Checkbox
                label="No Invoice?"
                checked={form.isUnInvoiced}
                onChange={(_, v) => onValueChange("isUnInvoiced", v || false)} />
        </div>;
    }

    const buttons = () => {
        return <div className="ms-Grid-row pv-15">
            <div className={width6 + " pl-0"}>
                <DefaultButton onClick={onClose} styles={defaultButtonStyles}>
                    Cancel
                </DefaultButton>
            </div>
            <div className={width6 + " pr-0"}>
                <PrimaryButton onClick={onSubmit} styles={primaryButtonStyles}>
                    Submit
                </PrimaryButton>
            </div>
        </div>;
    }

    return <>
        <Modal
            titleAriaId={_titleId}
            subtitleAriaId={_subtitleId}
            isOpen={true}
            onDismiss={onClose}
            isBlocking={true}
            isModeless={false}
            styles={StyleUtils.getModalWidthStyles(450)}
        >
            <div>
                <div className="popup-header">
                    {header()}
                </div>
                <div id={_subtitleId} className="popup-body ph-20 pv-10">
                    <div className="ms-Grid">
                        {sortByPicker()}
                        {reasonPicker()}
                        {trackingPicker()}
                        {allWarehouseCheckbox()}
                        {openOnlyCheckbox()}
                        {noInvoiceCheckbox()}
                        {buttons()}
                    </div>
                </div>
            </div>
        </Modal>
    </>;
}